import { OptionsType } from './../../../../shared/enums/options-type/options-type.module';
import { Page } from './../../../../models/page.model';
import { ConnectionDefinitionService } from './../../../../services/connectionDefinition/connection-definition.service';
import { GeneralParameterService } from '../../../../services/generalparameter/generalparameter.service';
import { SelectType } from '../../../../shared/enums/select-type/select-type.module';
import { AfterViewChecked, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { RoleType } from '../../../../shared/enums/role-type/role-type.module';
import { ActivatedRoute, Router } from '@angular/router';
import { PageService } from '../../../../services/page/page.service';
import { SnackbarService } from '../../../../services/shared/snackbar/snackbar.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '../../../../services/shared/dialog/dialog.service';
import { TranslationService } from '../../../../services/translation/translation.service';
import { RolesList } from '../../../../models/rolesList.model';
import { Block } from '../../../../models/block.model';
import { ComponentType } from '../../../../shared/enums/component-type/component-type.module';
import { InputType } from '../../../../shared/enums/input-type/input-type.module';
import { ComponentsGroup } from '../../../../models/componentGroup.model';
import { Component as ComponentModel } from '../../../../models/component.model';
import { MatSidenav } from '@angular/material/sidenav';
import { FileCategory } from '../../../../models/fileCategory.model';
import { GeneralParameter } from '../../../../models/generalParameter.model';
import { AddConditionModalComponent } from '../../../../shared/components/add-condition-modal/add-condition-modal.component';
import { UtilsService } from '../../../../services/shared/utils/utils.service';
import { BlockConfigComponent } from './block-config/block-config.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { PageParentStatus } from '../../../../models/pageParentStatus.model';
import { Role } from '../../../../models/role.model';
import { PreviewChooseModalComponent } from '../../../../shared/components/preview-choose-modal/preview-choose-modal.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Connection } from '../../../../models/connection.model';
import { RegexCategory } from '../../../../models/regexCategory.model';
import { PageType } from '../../../../shared/enums/page-type/page-type.module';
import { SelectOption } from '../../../../models/selectOption.model';
import { App } from '../../../../shared/enums/app/app.module';
import { ConnectionDefinition } from '../../../../models/connectionDefinition.model';
import { Rule } from '../../../../models/rule.model';
import { ElementCopied } from '../../../../models/elementCopied.model';
import { ElementType } from '../../../../shared/enums/element-type/element-type.module';
import { LocalStorageService } from '../../../../services/shared/local-storage/local-storage.service';
import { Tag } from '../../../../models/tag.model';
import { TagsModalComponent } from '../../../../shared/components/tags-modal/tags-modal.component';
import { Subject, takeUntil } from 'rxjs';
import { Accessibility } from '../../../../models/accessibility.model';
import { ConnectionComponent } from './connection/connection.component';
import { RefBusinessLists } from '../../../../models/refBusinessLists.model';
import { CustomerPageDataService } from '../../../../services/customerPageData/customerPageData.service';
import { CommonService } from '../../../../services/shared/common/common.service';
import { LoadingService } from '../../../../services/loading/loading.service';
import { PageHistoryModalComponent } from '../../../../shared/components/page-history-modal/page-history-modal.component';
import { AngularEditorConfig } from '@wfpena/angular-wysiwyg';
import { EditorI18nService } from '../../../../services/editor-i18n/editor-i18n.service';
import { ComponentMask } from '../../../../models/componentMask.model';
import { EditOptionModalComponent } from '../../../../shared/components/edit-option-modal/edit-option-modal.component';

@Component({
  selector: 'app-page-config',
  templateUrl: './page-config.component.html',
  styleUrl: './page-config.component.css'
})
export class PageConfigComponent implements OnInit, OnDestroy, AfterViewChecked {

  private destroy$ = new Subject<void>();

  isEdited: boolean = false;
  isVersionEdited: boolean = false;
  isImported: boolean = false;
  private _editorText = '';
  private _editorBlockDoneText = '';

  get editorText() {
    return this._editorText;
  }

  set editorText(value: string) {
    this._editorText = value;
    this.selectedComponent!.config!.text = value;
  }

  get editorBlockDoneText() {
    return this._editorBlockDoneText;
  }

  set editorBlockDoneText(value: string) {
    this._editorBlockDoneText = value;
    this.page.blockDone!.title = value;
  }
  page: Page = {
    id: '00000000-0000-0000-0000-000000000000',
    version: "",
    title: this.translationService.translate('Empty'),
    type: PageType.OFFER,
    parentPage: undefined,
    blockDone: { buttonText: "", title: ""},
    blockSummary: { submitButtonText: "" },
    blocks: [],
    roles: [
      {
        name: RoleType.DELIVERY,
        isActive: true,
        accessibility: {
          visible: true,
          editable: false,
          submittable: true
        },
        guide: ""
      },
      {
        name: RoleType.CLIENTSERVICE,
        isActive: true,
        accessibility: {
          visible: true,
          editable: false,
          submittable: true
        },
        guide: ""
      },
      {
        name: RoleType.SALES,
        isActive: true,
        accessibility: {
          visible: true,
          editable: false,
          submittable: true
        },
        guide: ""
      },
      {
        name: RoleType.CUSTOMER,
        isActive: true,
        accessibility: {
          visible: true,
          editable: true,
          submittable: true
        },
        guide: ""
      },
      {
        name: RoleType.INTERN,
        isActive: true,
        accessibility: {
          visible: true,
          editable: false,
          submittable: false
        },
        guide: ""
      }
    ],
    offers: []
  };
  pageId: string | null = "";
  panelOpenState = false;
  ComponentType = ComponentType;
  InputType = InputType;
  SelectType = SelectType;
  PageType = PageType;
  ElementType = ElementType;
  OptionsType = OptionsType;
  App = App;
  fullRolesTrigger!: boolean;
  activeRightSideBar: string = 'componentAdd';

  currentStep: number = 0;

  selectedBlock: Block | null = null;
  selectedGroup: ComponentsGroup | null = null;
  selectedComponent: ComponentModel | null = null;


  fileCategories: FileCategory[] = [];
  fileTypes: string[] = [];
  selectTypes = Object.keys(SelectType)
    .filter(key => isNaN(Number(key)))
    .map(key => ({
      key,
      value: SelectType[key as keyof typeof SelectType]
    }));

  componentTypes = Object.keys(ComponentType)
    .filter(key => isNaN(Number(key)))
    .map(key => ({
      key,
      value: ComponentType[key as keyof typeof ComponentType]
    }));

  roleTypes = Object.keys(RoleType)
    .filter(key => isNaN(Number(key)) && key != 'ADMIN')
    .map(key => ({
      key,
      value: RoleType[key as keyof typeof RoleType]
    }));

  optionTypes = Object.keys(OptionsType)
    .filter(key => isNaN(Number(key)))
    .map(key => ({
      key,
      value: OptionsType[key as keyof typeof OptionsType]
    }));

  fullRoles: RolesList[] = [];

  conditionSources: ComponentModel[] = [];

  newBlocksIds: string[] = [];
  newComponentsIds: string[] = [];

  pagesParentAvailable: Page[] = [];
  isParent: boolean = true;
  isMobile = window.innerWidth <= 1023;

  regexTypes: RegexCategory[] = [];
  maskConfigs: ComponentMask[] = [];

  initPage: boolean = true;

  connectionsDefinitions: ConnectionDefinition[] = [];

  componentDisplayTypes = [
    { label: 'INPUT_TEXT', value: 'INPUT_TEXT' },
    { label: 'TEXT_AREA', value: 'TEXT_AREA' },
    { label: 'NUMBER', value: 'NUMBER' },
    { label: 'DATE', value: 'DATE' },
    { label: 'COLOR', value: 'COLOR' },
    { label: 'FILE', value: 'FILE' },
    { label: 'LIST_DROP', value: 'LIST_DROP' },
    { label: 'LIST_NO_DROP', value: 'LIST_NO_DROP' },
    { label: 'LIST_CARD', value: 'LIST_CARD' },
    { label: 'CHOICE_BUTTON', value: 'CHOICE_BUTTON' },
    { label: 'SCHEDULE', value: 'SCHEDULE' },
    { label: 'BUTTON', value: 'BUTTON' },
    { label: 'TEXT', value: 'TEXT' },
    { label: 'TITLE', value: 'TITLE' },
    { label: 'HTML', value: 'HTML' },
    { label: 'ADDRESS', value: 'ADDRESS' },
    { label: 'INTITULE', value: 'INTITULE' },
    { label: 'URL', value: 'URL' },
    { label: 'VISUAL_PUBLICATION', value: 'VISUAL_PUBLICATION' },
    { label: 'ACTIVITY_PRESTATIONS', value: 'ACTIVITY_PRESTATIONS' }
  ];

  permissionTypes = [
    'Visible',
    'Editable'
  ]

  searchComponentsFilters = {
    text: '',
    types: [] as string[],
    onlyNew: false,
    onlyMultiple: false,
    onlyConditions: false,
    onlyConnections: false,
    withKeyIndicatorWeight: false,
    withoutKeyIndicatorWeight: false,
    includedRole: '',
    excludedRole: '',
    accessibility: ''
  };

  refBusinessLists: RefBusinessLists = { activities: [], certifications: [], hours: [], countries: [], urlTypes: [] };

  config: AngularEditorConfig = {
    editable: true,
    sanitize: false,
    spellcheck: false,
    outline: false,
    height: 'auto',
    minHeight: '75px',
    toolbarHiddenButtons: [
      ['insertVideo', 'insertImage', 'fontName']
    ],
    defaultFontName: '"Poppins", sans-serif',
    defaultFontSize: '2',
    enableToolbar: true,
    placeholder: ''
  };

  @ViewChild('rightSidenav') rightSidenav!: MatSidenav;
  @ViewChild('generalPanel') generalPanel!: MatExpansionPanel;
  @ViewChild('answersPanel') answersPanel!: MatExpansionPanel;
  @ViewChild('keyindicatorPanel') keyindicatorPanel!: MatExpansionPanel;
  @ViewChild('rolesPanel') rolesPanel!: MatExpansionPanel;
  @ViewChild('conditionsPanel') conditionsPanel!: MatExpansionPanel;
  @ViewChild('connectionsPanel') connectionsPanel!: MatExpansionPanel;
  @ViewChild('leftSidenav') leftSidenav!: MatSidenav;
  @ViewChildren('blockComponent') blockComponents!: QueryList<BlockConfigComponent>;
  @ViewChild('mainContent') mainContent!: ElementRef;
  @ViewChild('stepper') stepper!: ElementRef;
  @ViewChildren('autoResizeTextarea') textareas!: QueryList<ElementRef>;
  @ViewChildren(ConnectionComponent) connectionComponents!: QueryList<ConnectionComponent>;
  @ViewChild('editorTextArea', { read: ElementRef })
  editorEl!: ElementRef<HTMLElement>;
  @ViewChild('editorBlockDoneTextArea', { read: ElementRef })
  editorBlockDoneEl!: ElementRef<HTMLElement>;
  translated = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private pageService: PageService,
    private snackBar: SnackbarService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    public translationService: TranslationService,
    public generalParameterService: GeneralParameterService,
    public utils: UtilsService,
    private connectionDefinitionService: ConnectionDefinitionService,
    private lStorage: LocalStorageService,
    private renderer: Renderer2,
    private customerPageDataService: CustomerPageDataService,
    private commonService: CommonService,
    private loadingService: LoadingService,
    private editorI18n: EditorI18nService

  ) { }

  ngOnInit(): void {
    this.loadingService.show();
    this.pageId = this.route.snapshot.paramMap.get('id');
    if (this.pageId === '00000000-0000-0000-0000-000000000000') {
      this.router.navigate(['/']);
    }

    this.getPage();
    this.getAvailableParentPages();
    this.getFileCategories();
    this.getRegexes();
    this.getMasks();
    this.getConnectionsDefinitions();
    this.getCopiedElements();

    setTimeout(() => {
      this.adjustAllTextareasHeight();
    }, 1);

    this.searchComponentsFilters.types = this.componentDisplayTypes.map(option => option.value);
  }
  ngAfterViewChecked(): void {
    if (this.translated) return;

    const toolbarExists = document.querySelector('.angular-editor-toolbar');
    if (!toolbarExists) return;

    this.editorI18n.translateAll();
    this.translated = true;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getPage(): void {
    if (this.pageId !== null) {
      this.pageService.getPageDetails(this.pageId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: Page) => {
            this.page = data;
            this.buildSideBarSettings('page', undefined, undefined);
            this.loadingService.hide();

            this.getRefBusinessList();
          },
          error: (error) => {
            this.snackBar.showError(this.translationService.translate('Error fetching page'));
            this.loadingService.hide();
          }
        });
    } else {
      this.snackBar.showError(this.translationService.translate('ID is null'));
      this.loadingService.hide();
    }
  }

  getAvailableParentPages(): void {
    if (this.pageId !== null) {
      this.pageService.getAvailableParentPages(this.pageId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: PageParentStatus) => {
            this.pagesParentAvailable = data.pagesParentAvailable;
            this.isParent = data.isParent;
          },
          error: (error) => {
            this.snackBar.showError(this.translationService.translate('Error fetching pages'));
          }
        })
    }
  }

  getParentName(): string {
    var name = "";
    if (this.page.parentPage !== undefined && this.page.parentPage !== null) {
      name = name + this.pagesParentAvailable.find(x => x.id === this.page.parentPage?.id)?.title;
    }

    return name;
  }

  getRefBusinessList() {
    this.loadingService.show();
    this.customerPageDataService.getRefBusinessLists()
      .subscribe({
        next: (lists: RefBusinessLists) => {
          this.refBusinessLists = lists;
          this.loadingService.hide();
        },
        error: (error) => {
          this.snackBar.showError(this.translationService.translate('Error on fetching refBusiness lists'));
          this.loadingService.hide();
        }
      });
  }

  onSave(): void {
    this.dialogService.confirm(this.translationService.translate('Confirm Save'), this.translationService.translate('Are you sure you want to save this page?')).then((confirmed) => {
      if (confirmed) {
        const formData = new FormData();

        this.page = this.evaluatePage(this.page);

        formData.append('pageModelJson', JSON.stringify(this.page));

        if (this.page.id == '00000000-0000-0000-0000-000000000000') {
          this.pageService.createPage(this.page)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (data: Page) => {
                let pageData = data;
                this.page = pageData;
                this.pageId = pageData.id!;

                this.router.navigate(['/admin/pages', this.pageId], {
                  replaceUrl: true
                });

                this.newBlocksIds = [];
                this.newComponentsIds = [];

                this.getAvailableParentPages();

                this.snackBar.showSuccess(this.translationService.translate('Success saving this page'));
                this.isEdited = false;
                this.isVersionEdited = false;
                this.isImported = false;
                this.page.current = true;
              },
              error: (error) => {
                this.snackBar.showError(this.translationService.translate('Error saving this page'));
              }
            });
        } else {
          this.pageService.updatePage(this.page.id!, formData)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (data: Page) => {
                this.snackBar.showSuccess(this.translationService.translate('Success saving this page'));
                this.newBlocksIds = [];
                this.newComponentsIds = [];
                this.page.version = data.version;
                this.isEdited = false;
                this.isVersionEdited = false;
                this.isImported = false;
                this.page.current = true;
              },
              error: (error) => {
                this.snackBar.showError(this.translationService.translate('Error saving this page'));
              }
            });
        }
      }
    });
  }

  evaluatePage(page: Page): Page {
    page.blocks?.forEach(x => {
      x.subCode = x.subCode == null ? "" : x.subCode.trim().toUpperCase();
      x.componentGroups.forEach(group => {
        group.components.forEach(component => {
          //evaluate connection (removes connections with missing fields)
          if (component.connections && component.connections.length > 0) {
            component.connections = component.connections
              .filter(connection =>
                connection.direction !== null && connection.direction != undefined &&
                connection.trigger !== null && connection.trigger != undefined &&
                connection.connectionDefinition !== null && connection.connectionDefinition !== undefined &&
                (
                  (connection.connectionDefinition.app === App.CDC && component.tag && component.tag?.length > 0) ||
                  (connection.connectionDefinition.values != null && connection.connectionDefinition.values !== undefined && connection.connectionDefinition.values.length > 0)
                )
              );
          }

          //evaluate options (removes invalid and repeated options from a select component)
          if (component.type === ComponentType.SELECT) {
            if (component.config!.optionsType == OptionsType.CUSTOM) {
              if (component.config?.options && component.config?.options.length > 0) {
                component.config!.options! = component.config.options
                  .filter(option =>
                    option.value != null &&
                    option.value != undefined &&
                    option.value.replaceAll(" ", "") !== "" &&
                    option.display != null &&
                    option.display != undefined &&
                    option.display.replaceAll(" ", "") !== ""
                  )
                  .reduce((uniqueOptions, option) => {
                    if (!uniqueOptions.seen.has(option.value)) {
                      uniqueOptions.seen.add(option.value);
                      uniqueOptions.result.push(option);
                    }
                    return uniqueOptions;
                  }, { seen: new Set<string>(), result: [] as SelectOption[] }).result as SelectOption[];
              }
            }
            else {
              component.config!.options! = [];
            }
          }

          //evaluate conditions (removes repeated rules from a condition)
          if (component.conditions && component.conditions.length > 0) {
            component.conditions.forEach(condition => {
              if (condition.rules && condition.rules.length > 0) {
                condition.rules = condition.rules.reduce((uniqueRules, rule) => {
                  if (!uniqueRules.some(r => r.action === rule.action && r.value === rule.value && r.operatorType === rule.operatorType)) {
                    uniqueRules.push(rule);
                  }
                  return uniqueRules;
                }, [] as Rule[]);
              }
            });
          }
        });
      });
    });

    return page;
  }

  onAddBlock(): void {
    const newBlock: Block = {
      id: this.utils.generateGUID(),
      title: this.translationService.translate('Empty'),
      subCode: "",
      isMultiple: false,
      iteration: 1,
      componentGroups: [],
      conditions: [],
      roles: [
        {
          name: RoleType.DELIVERY,
          isActive: false,
          accessibility: {
            visible: this.page.roles!.find(x => x.name == RoleType.DELIVERY)!.accessibility.visible,
            editable: this.page.roles!.find(x => x.name == RoleType.DELIVERY)!.accessibility.editable
          }
        },
        {
          name: RoleType.CLIENTSERVICE,
          isActive: false,
          accessibility: {
            visible: this.page.roles!.find(x => x.name == RoleType.CLIENTSERVICE)!.accessibility.visible,
            editable: this.page.roles!.find(x => x.name == RoleType.CLIENTSERVICE)!.accessibility.editable
          }
        },
        {
          name: RoleType.SALES,
          isActive: false,
          accessibility: {
            visible: this.page.roles!.find(x => x.name == RoleType.SALES)!.accessibility.visible,
            editable: this.page.roles!.find(x => x.name == RoleType.SALES)!.accessibility.editable
          }
        },
        {
          name: RoleType.CUSTOMER,
          isActive: false,
          accessibility: {
            visible: this.page.roles!.find(x => x.name == RoleType.CUSTOMER)!.accessibility.visible,
            editable: this.page.roles!.find(x => x.name == RoleType.CUSTOMER)!.accessibility.editable
          }
        },
        {
          name: RoleType.INTERN,
          isActive: false,
          accessibility: {
            visible: this.page.roles!.find(x => x.name == RoleType.INTERN)!.accessibility.visible,
            editable: false
          }
        }
      ]
    };
    if (this.page !== null) {
      this.page.blocks!.push(newBlock);
      const lastIndex = this.page.blocks!.length - 1;
      this.goToStep(lastIndex);
    }

    this.newBlocksIds.push(newBlock.id);
    this.isEdited = true;
  }

  onRemoveBlock(): void {
    this.dialogService.confirm(this.translationService.translate('Confirm Delete'), this.translationService.translate('Are you sure you want to delete this block?')).then((confirmed) => {
      if (confirmed && this.selectedBlock !== null && this.selectedBlock !== undefined) {
        var blockIndex = this.page.blocks!.findIndex(block => block.id === this.selectedBlock!.id);

        this.page.blocks!.splice(blockIndex, 1);

        //update list of new blocks/components
        this.newBlocksIds = this.newBlocksIds.filter(blockId => blockId !== this.selectedBlock!.id);

        if (this.page.blocks!.length > 0) {
          this.previousStep();
        }
        else {
          this.selectedBlock = null;
          this.selectedGroup = null;
          this.selectedComponent = null;
          this.activeRightSideBar = "pageSettings";
        }

        this.isEdited = true;
      }
    });
  }

  //CHANGE BLOCK
  nextStep(): void {
    if (this.currentStep < this.page.blocks!.length) {
      this.currentStep++;
      this.updateCurrentBlock();
    }
  }

  previousStep(): void {
    if (this.currentStep > 0) {
      this.currentStep--;
      this.updateCurrentBlock();
    }
  }

  goToStep(index: number): void {
    this.currentStep = index;
    this.updateCurrentBlock();
  }

  updateCurrentBlock() {
    setTimeout(() => {
      if (this.page && this.page.blocks && this.page.blocks[this.currentStep]) {
        this.selectedBlock = this.page.blocks[this.currentStep];

        //reset selected component to new block
        if (!this.initPage) {
          this.buildSideBarSettings("block", undefined, undefined);
        }
        else {
          this.initPage = false;
        }
      } else {
        this.selectedBlock = null;
      }

      this.commonService.adjustAddComponentWidth(this.renderer);
    }, 0);
  }

  openBlock(index: number) {
    this.currentStep = index;
    this.updateCurrentBlock();
  }

  //CHANGE SELECTED PAGE/BLOCK/GROUP/COMPONENT
  onPageSelected() {
    this.selectedGroup = null;
    this.selectedComponent = null;
    this.activeRightSideBar = "pageSettings";
    this.rightSidenav.toggle(true);
    this._editorBlockDoneText = this.InitEditor(this.page.blockDone!.title);
    if (this.isMobile) {
      this.leftSidenav.close();
    }
  }

  onBlockSelected() {
    this.selectedGroup = null;
    this.selectedComponent = null;
    setTimeout(() => {
      this.activeRightSideBar = "blockSettings";
      this.rightSidenav.toggle(true);
      if (this.isMobile) {
        this.leftSidenav.close();
      }
    });
  }

  onGroupSelected(groupId: string) {
    this.selectedGroup = this.page.blocks!.find(block => block.id === this.selectedBlock?.id)?.componentGroups.find(group => group.id === groupId) ?? null;
    this.selectedComponent = null;
    this.activeRightSideBar = "groupSettings";
    this.rightSidenav.toggle(true);
    if (this.isMobile) {
      this.leftSidenav.close();
    }
  }

  onComponentSelected(componentId: string, groupId: string) {
    const selectedBlock = this.page.blocks!.find(block => block.id === this.selectedBlock?.id);

    this.selectedGroup = selectedBlock?.componentGroups.find(group => group.id === groupId) ?? null;
    this.selectedComponent = this.selectedGroup?.components.find(component => component.id === componentId) ?? null;
    this.activeRightSideBar = "componentSettings";
    this.rightSidenav.toggle(true);
    if (this.isMobile) {
      this.leftSidenav.close();
    }
    if (this.selectedComponent) {
      this._editorText = this.InitEditor(this.selectedComponent!.config!.text);
    }
    const componentIndex = this.selectedGroup!.components.findIndex(component => component.id === componentId);
    this.scrollToComponentInBlock(this.selectedBlock?.id, groupId, componentIndex);

    if (this.selectedComponent) {
      this.evaluateRegexType(this.selectedComponent.regex);

      if(this.selectedComponent.config && !this.selectedComponent.config.mask){
        this.selectedComponent.config.mask = this.selectedComponent.type == ComponentType.INPUT && this.selectedComponent.config?.inputType == InputType.TEXT ? {
          type: "NONE",
          mask: "",
          dropSpecialCharacters: false
        } : undefined;
      }
      this.maskSelected = this.selectedComponent.config?.mask?.type ?? "NONE";
    }

    if (this.selectedComponent && this.selectedComponent.type == ComponentType.SELECT
      && this.selectedComponent.config!.options && this.selectedComponent.config!.options.length > 0) {
      this.selectedComponent.config!.options.forEach(o => o.oldValue = o.value);
    }
  }


  scrollToComponentInBlock(blockId: string | undefined, groupId: string, componentIndex: number) {
    const blockComponent = this.blockComponents.find(block => block.block.id === blockId);
    blockComponent?.scrollToComponent(groupId, componentIndex);
  }

  buildSideBarSettings(type: string, groupId?: string, componentId?: string, open?: string) {

    if (type === "component" && componentId && groupId) {
      this.closeAllComponentSettingsPanels();
      this.onComponentSelected(componentId, groupId);
      setTimeout(() => {
        if (open) {
          if (open === "answers") {
            this.answersPanel.open();
          }
          else if (open === "roles") {
            this.rolesPanel.open();
          }
          else if (open === "conditions") {
            this.conditionsPanel.open();
          }
          else if (open === "connections") {
            this.connectionsPanel.open();
          }
          else if (open === "keyindicator") {
            this.keyindicatorPanel.open();
          }
        }
      }, 0);
    }
    else if (type === "group" && groupId) {
      this.onGroupSelected(groupId);
    }
    else if (type === "block") {
      this.onBlockSelected();
    }
    else if (type === "page") {
      this.onPageSelected();
      setTimeout(() => {
        if (this.isMobile) {
          this.rightSidenav.close();
          this.leftSidenav.close();
        }
      }, 1000);
    }

    this.refreshFullRoles(type);
    this.calculateAvailableSources();
  }
  closeAllComponentSettingsPanels() {
    this.generalPanel?.close();
    this.answersPanel?.close();
    this.keyindicatorPanel?.close();
    this.rolesPanel?.close();
    this.conditionsPanel?.close();
    this.connectionsPanel?.close();
  }

  rightSidenavToggle() {
    this.rightSidenav.toggle();
    if (this.isMobile) {
      this.leftSidenav.close();
    }
  }
  leftSidenavToggle() {
    this.leftSidenav.toggle();
    if (this.isMobile) {
      this.rightSidenav.close();
    }
  }

  refreshFullRoles(type: string) {
    this.fullRoles = [];
    if (type === "page") {
      this.fullRoles = [{
        type: "page",
        list: this.page.roles!
      }];
    }
    else if (type === "block" && this.selectedBlock) {
      this.fullRoles.push(
        {
          type: "page",
          list: this.page.roles!
        },
        {
          type: "block",
          list: this.selectedBlock.roles
        });
    }
    else if (type === "component" && this.selectedComponent && this.selectedBlock) {
      this.fullRoles.push(
        {
          type: "component",
          list: this.selectedComponent.roles!
        },
        {
          type: "block",
          list: this.selectedBlock.roles
        },
        {
          type: "page",
          list: this.page.roles!
        });
    }
  }


  //#region COMPONENT
  getExtensions(fileType: string): string {
    var extensions = this.fileCategories.find(x => x.type == fileType)?.values.join(', ');
    return extensions != null && extensions?.length > 0 ? extensions : "";
  }
  getFileCategories(): void {
    this.generalParameterService.getGeneralParameters('FileTypes')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (param: GeneralParameter[] | GeneralParameter) => {
          if (param != null && param.values.length > 0) {
            this.fileCategories = (param.values) as FileCategory[];
            this.fileTypes = this.fileCategories.map(x => x.type);
          }
        },
        error: (error) => {
          this.fileCategories = [];
        }
      });
  }

  getComponentFullType() {
    var type = "";

    if (this.selectedComponent) {
      type += this.translationService.translate(ComponentType[this.selectedComponent.type!]);

      if (this.selectedComponent.type === ComponentType.INPUT && this.selectedComponent.config) {
        type += ' ' + this.translationService.translate(InputType[this.selectedComponent.config.inputType!]);
      }
      else if (this.selectedComponent.type === ComponentType.SELECT && this.selectedComponent.config) {
        type += ' ' + this.translationService.translate(SelectType[this.selectedComponent.config.selectType!]);
      }
    }
    return type;
  }

  //SELECT OPTIONS
  removeOption(index: number): void {
    if (this.selectedComponent && this.selectedComponent.config?.options && index > -1) {
      this.selectedComponent.config.options.splice(index, 1);
      this.isEdited = true;
    }
  }

  removeRulesWithKey(key: string): void {
    // catch components that use current component as a condition, and then remove rules with this key
    this.page.blocks!.find(block => block.id === this.selectedBlock?.id)?.componentGroups.forEach(group => {
      group.components.filter(x => x.conditions?.some(y => y.componentId == this.selectedComponent?.id)).forEach(component => {
        component.conditions?.forEach(condition => {
          condition.rules = condition.rules.filter(rule => rule.value !== key);
        });
      });
    });
  }
  addOption(): void {
    var option: SelectOption = {
      value: "",
      display: ""
    }

    if (this.selectedComponent && this.selectedComponent.config) {
      if (this.selectedComponent.config.options) {
        this.selectedComponent.config.options.push(option);
      }
      else {
        this.selectedComponent.config.options = [option];
      }

      this.isEdited = true;
    }
  }

  onChangeOptionValue(option: SelectOption, newValue: string): void {
    this.isEdited = true;
    if (this.selectedBlock && this.selectedComponent && this.selectedComponent.config!.options) {
      const isRepetead = this.selectedComponent.config!.options.map(option => option.value?.trim()).filter(v => v == newValue).length > 1;
      if (!isRepetead) {
        var blockComponents = this.selectedBlock.componentGroups.flatMap((group: ComponentsGroup) => group.components);
        var conditionedComponent = blockComponents
          .filter(x => x.conditions?.some(c => c.componentId == this.selectedComponent!.id && c.rules.some(r => r.value == option.oldValue)));

        //update conditioned by changed option
        if (conditionedComponent.length > 0) {
          conditionedComponent.forEach(c => {
            c.conditions?.flatMap(c => c.rules).filter(r => r.value == option.oldValue).forEach(r => r.value = newValue);
          });
        }
        option.oldValue = newValue;
      }
    }
  }

  hasEmptyKeyOrValue(): boolean {
    if (this.selectedComponent && this.selectedComponent.config && this.selectedComponent.config.options) {
      return this.selectedComponent.config.options.some(option =>
        !option.value?.trim() || !option.display?.trim()
      );
    }
    return false;
  }

  hasDuplicatedValues(): boolean {
    if (this.selectedComponent && this.selectedComponent.config && this.selectedComponent.config.options) {
      const values = this.selectedComponent.config.options.map(option => option.value?.trim());
      const uniqueValues = new Set(values);
      return uniqueValues.size !== values.length;
    }
    return false;
  }

  handleSelectOptionType(option: string) {
    this.selectedComponent!.config!.optionsType = parseInt(option);

    if (this.selectedComponent!.config!.optionsType != OptionsType.CUSTOM
      && this.selectedComponent?.config?.options && this.selectedComponent?.config?.options?.length > 0) {
      this.dialogService.confirm(
        this.translationService.translate('Change Option Type?'),
        this.translationService.translate('This will remove your current select options.') + this.translationService.translate('Are you sure you want to continue?')
      ).then((confirmed) => {
        if (confirmed) {
          this.selectedComponent!.config!.options = [];
        }
        else {
          this.selectedComponent!.config!.optionsType = OptionsType.CUSTOM;
        }
      });
    }

    this.isEdited = true;
  }

  canChangeOptionsType() {
    return !this.selectedComponent?.connections?.some(x => x.connectionDefinition?.app == App.CONTENT);
  }

  updateSelectOptions(subTypeSelected: string | undefined) {
    if (this.selectedComponent && this.selectedComponent.config) {
      this.selectedComponent!.config!.options = [];
      if (subTypeSelected == 'certification') {
        this.selectedComponent!.config!.optionsType = OptionsType.CERTIFICATIONS;
      }
    }
  }

  onOpenOptionEditorModal(index: number)
  {
    if(this.selectedComponent && this.selectedComponent.config && this.selectedComponent.config.options){
      var option = this.selectedComponent.config.options[index];
      //modal
      const dialogRef = this.dialog.open(EditOptionModalComponent, {
        width: '90%',
        height: '80%',
        data: {
          option: structuredClone(option)
        }
      });

      dialogRef.afterClosed().subscribe(optionUpdated => {
        if(optionUpdated != undefined){
          this.selectedComponent!.config!.options![index].value = optionUpdated.value;
          this.onChangeOptionValue(this.selectedComponent!.config!.options![index], optionUpdated.value);

          this.selectedComponent!.config!.options![index].display = optionUpdated.display;
          this.isEdited = true;
        }
      });
    }
  }

  onAddComponent(groupId: string, componentId: string) {
    this.newComponentsIds.push(componentId);
    this.buildSideBarSettings("component", groupId, componentId);
    setTimeout(() => {
      this.scrollToComponentInBlock(this.selectedBlock?.id, groupId, this.selectedGroup?.components.findIndex(component => component.id === componentId) || 0);
    }, 0);
    this.isEdited = true;
  }

  onRemoveComponent(): void {
    this.dialogService.confirm(
      this.translationService.translate('Confirm Delete'),
      this.translationService.translate('Are you sure you want to delete this component?')
    ).then((confirmed) => {
      if (confirmed) {
        if (this.selectedBlock && this.selectedComponent && this.selectedGroup) {

          var componentId = this.selectedComponent.id;
          var groupId = this.selectedGroup.id;

          const componentIndex = this.selectedGroup.components.findIndex(x => x.id === componentId);
          if (componentIndex !== -1) {
            //delete component
            const removedComponent = this.selectedGroup.components[componentIndex];
            this.selectedGroup.components.splice(componentIndex, 1);

            //delete group if empty
            if (this.selectedGroup.components.length === 0) {
              const groupIndex = this.selectedBlock.componentGroups.findIndex(x => x.id === groupId);
              if (groupIndex !== -1) {
                const removedGroup = this.selectedBlock!.componentGroups[groupIndex];
                this.selectedBlock.componentGroups.splice(groupIndex, 1);

                //Reorder Next Groups (Move Down One Position)
                this.selectedBlock.componentGroups.forEach(group => {
                  if (group.order !== undefined && removedGroup.order !== undefined && group.order > removedGroup.order) {
                    group.order--;
                  }
                });
              }
            }
            // change to default properties when single component
            else if (this.selectedGroup.components.length === 1 && this.selectedGroup.components[0].type != ComponentType.ACTIVITY_PRESTATIONS) {
              this.selectedGroup.multipleConfig!.initQuantity = 1;
              this.selectedGroup.multipleConfig!.maxQuantity = 1;
              this.selectedGroup.multipleConfig!.minQuantity = 1;
            }

            //Reorder Next Components (Move Down One Position)
            this.selectedGroup.components.forEach(component => {
              if (component.order !== undefined && removedComponent.order !== undefined && component.order > removedComponent.order) {
                component.order--;
              }
            });

            //remove conditions associated
            this.selectedBlock.componentGroups.forEach(group => {
              group.components.forEach(component => {
                component.conditions = component.conditions?.filter(condition => condition.componentId !== componentId);
              });
            });
          }

          this.buildSideBarSettings("block", undefined, undefined);
          this.calculateAvailableSources();
          this.newComponentsIds = this.newComponentsIds.filter(x => x !== componentId);
          this.isEdited = true;
        }
      }
    });
  }

  //get component on current block
  getBlockComponentById(targetComponentId: string): ComponentModel | undefined {
    for (let group of this.selectedBlock!.componentGroups) {
      const foundComponent = group.components.find(component => component.id === targetComponentId);
      if (foundComponent) {
        return foundComponent;
      }
    }
    return undefined;
  }

  //Conditions
  existConditionDisplay(): boolean {

    var exists = false;

    if (this.selectedComponent && this.selectedComponent.config) {
      var exists = this.selectedComponent?.conditions!.some(condition => condition.rules.some(rule => rule.action === 'display'));

      if (!exists) {
        this.selectedComponent.config.conditionComponentTarget = undefined;
        this.selectedComponent.config.conditionPosition = undefined;
      } else {
        if (!this.selectedComponent.config.conditionComponentTarget) {
          this.selectedComponent.config.conditionComponentTarget = this.selectedComponent.conditions?.filter(condition => condition.rules.filter(rule => rule.action === "display"))[0].componentId;
        }
        if (this.selectedComponent.config.conditionPosition === undefined) {
          this.selectedComponent.config.conditionPosition = "apart";
        }
      }
    }

    return exists;
  }
  onRemoveCondition(conditionIndex: number): void {
    this.dialogService.confirm(this.translationService.translate('Confirm Delete'), this.translationService.translate('Are you sure you want to delete this condition?')).then((confirmed) => {
      if (confirmed && this.selectedComponent) {
        this.selectedComponent.conditions?.splice(conditionIndex, 1);
        this.calculateAvailableSources();
        this.isEdited = true;
      }
    });
  }
  onAddCondition(): void {
    this.calculateAvailableSources();
    if (this.conditionSources.length > 0) {
      const dialogRef = this.dialog.open(AddConditionModalComponent, {
        width: '500px',
        data: {
          sources: this.conditionSources
        }
      });

      dialogRef.afterClosed().subscribe(newCondition => {
        if (newCondition && this.selectedComponent!.conditions) {
          this.selectedComponent!.conditions.push(newCondition);
        }
        this.calculateAvailableSources();
        this.isEdited = true;
      });
    }
  }
  calculateAvailableSources(): void {
    if (this.selectedBlock && this.selectedComponent) {
      var blockComponents = this.selectedBlock.componentGroups.flatMap((group: ComponentsGroup) => group.components);
      var conditionComponentIds = this.selectedComponent.conditions!.map(condition => condition.componentId);

      // catch components that use current component as condition (exclude them)
      var conditionedComponentIds = blockComponents.filter(x => x.conditions?.some(y => y.componentId == this.selectedComponent!.id)).map(component => component.id);

      this.conditionSources = blockComponents.filter(component =>
        component.id !== this.selectedComponent!.id
        && component.type != ComponentType.SCHEDULE
        && component.type != ComponentType.TEXT
        && component.type != ComponentType.BUTTON
        && component.type != ComponentType.TITLE
        && component.type != ComponentType.HTML
        && component.type != ComponentType.ADDRESS
        && component.type != ComponentType.INTITULE
        && component.type != ComponentType.URL
        && component.type != ComponentType.VISUAL_PUBLICATION
        && component.type != ComponentType.ACTIVITY_PRESTATIONS
        && !conditionComponentIds.includes(component.id)
        && !conditionedComponentIds.includes(component.id));

      this.calculateConditionClosedTargets();
    }
  }


  onAddConnection(): void {
    var newConnection: Connection = {
      id: this.utils.generateGUID(),
      connectionDefinition: undefined,
      direction: undefined,
      trigger: undefined
    }

    this.selectedComponent!.connections?.push(newConnection);
    this.isEdited = true;
  }
  onRemoveConnection(connectionIndex: number): void {
    this.dialogService.confirm(this.translationService.translate('Confirm Delete'), this.translationService.translate('Are you sure you want to delete this connection?')).then((confirmed) => {
      if (confirmed && this.selectedComponent) {
        this.selectedComponent.connections?.splice(connectionIndex, 1);
        this.isEdited = true;
      }
    });
  }

  //#endregion

  adjustAddComponentWidth(): void {
    this.commonService.adjustAddComponentWidth(this.renderer);
  }

  handleSelectType(option: string) {
    this.selectedComponent!.config!.selectType = parseInt(option);

    //verify if has conditioned closed when change select type to dropdown
    if (this.selectedComponent!.config!.selectType == SelectType.LIST_DROP) {
      var conditionedComponents = this.selectedBlock?.componentGroups
        .flatMap(x => x.components)
        .filter(x =>
          x.config?.conditionPosition?.toLowerCase() == 'closed'
          && x.config.conditionComponentTarget == this.selectedComponent?.id);

      conditionedComponents?.forEach(x => {
        x.config!.conditionComponentTarget = undefined;
        x.config!.conditionPosition = 'apart';
      });
    }

    this.isEdited = true;
  }

  adjustAllTextareasHeight() {
    this.textareas.forEach((textarea: ElementRef) => {
      this.utils.adjustTextareaHeight(textarea.nativeElement);
    });
  }

  adjustTextareaHeight(event: Event): void {
    this.utils.adjustTextareaHeight(event.target as HTMLTextAreaElement);
  }

  onRemoveGroup(): void {
    this.dialogService.confirm(
      this.translationService.translate('Confirm Delete'),
      this.translationService.translate('Are you sure you want to delete this group?')
    ).then((confirmed) => {
      if (confirmed) {
        if (this.selectedBlock && this.selectedGroup) {

          var groupId = this.selectedGroup.id;
          const groupIndex = this.selectedBlock.componentGroups.findIndex(x => x.id === groupId);

          if (groupIndex !== -1) {

            //delete group
            const componentsRemoved = this.selectedGroup.components.map(component => component.id);
            const removedGroup = this.selectedBlock.componentGroups[groupIndex];
            this.selectedBlock.componentGroups.splice(groupIndex, 1);

            //Reorder Next Groups (Move Down One Position)
            this.selectedBlock.componentGroups.forEach(group => {
              if (group.order !== undefined && removedGroup.order !== undefined && group.order > removedGroup.order) {
                group.order--;
              }
            });

            //remove conditions associated
            this.selectedBlock.componentGroups.forEach(group => {
              group.components.forEach(component => {
                component.conditions = component.conditions?.filter(condition => !componentsRemoved.includes(condition.componentId));
              });
            });

            //remove from newList
            this.newComponentsIds = this.newComponentsIds.filter(x => !componentsRemoved.includes(x));
          }

          this.buildSideBarSettings("block", undefined, undefined);
          this.calculateAvailableSources();
          this.isEdited = true;
        }
      }
    });
  }

  resetMultipleConfig() {
    var current = this.selectedComponent?.config?.multipleAnswers;
    if (current === false && this.selectedComponent && this.selectedComponent.multipleConfig) {
      this.selectedComponent.multipleConfig.initQuantity = 1;
      this.selectedComponent.multipleConfig.minQuantity = 1;
      this.selectedComponent.multipleConfig.maxQuantity = 1;
      this.selectedComponent.multipleConfig.textBtnMultiple = "";
      this.selectedComponent.multipleConfig.haveIndexTitles = false;
    }
    this.isEdited = true;
  }

  conditionClosedTargets: string[] = [];
  calculateConditionClosedTargets() {

    var targetsClosed = this.selectedComponent?.conditions!
      .filter(condition =>
        this.selectedBlock?.componentGroups.some(group =>
          group.components.some(component =>
            component.id === condition.componentId &&
            (
              component.type !== ComponentType.SELECT ||
              (component.type === ComponentType.SELECT && component.config?.selectType !== SelectType.LIST_DROP)
            ) &&
            (
              component.type !== ComponentType.INPUT ||
              (component.type === ComponentType.INPUT && component.config?.inputType !== InputType.COLOR_PICKER && component.config?.inputType !== InputType.FILE)
            )
          )
        )
      )
      .map(condition => condition.componentId);



    this.conditionClosedTargets = targetsClosed === undefined ? [] : targetsClosed;
  }

  fixText(event: Event, type: string) {
    if (this.selectedComponent) {
      if (type === 'title' && this.selectedComponent.title) {
        this.selectedComponent.title = this.selectedComponent.title.trim();
      }
      else if (type === 'description' && this.selectedComponent.description) {
        this.selectedComponent.description = this.selectedComponent.description.trim();
      }
      else if (type === 'helpText' && this.selectedComponent.helpText) {
        this.selectedComponent.helpText = this.selectedComponent.helpText.trim();
      }
      else if (type === 'text' && this.selectedComponent.config?.text) {
        this.selectedComponent.config.text = this.selectedComponent.config.text.trim();
        if (this.selectedComponent.type == ComponentType.HTML) {
          this.selectedComponent.config.text = this.utils.beautifyHtml(this.selectedComponent.config.text);
        }
      }
      else if (type === 'tag' && this.selectedComponent.tag) {
        this.selectedComponent.tag = this.selectedComponent.tag.trim();
      }
      else if (type === 'regex' && this.selectedComponent.regex) {
        this.selectedComponent.regex = this.selectedComponent.regex.trim();
      }
      else if (type === 'exportTag' && this.selectedComponent.exportTag) {
        this.selectedComponent.exportTag = this.selectedComponent.exportTag.trim();
      }
      else if (type === 'mask' && this.selectedComponent.config?.mask?.mask) {
        this.selectedComponent.config.mask.mask = this.selectedComponent.config.mask.mask.trim();
      }
      this.isEdited = true;

      setTimeout(() => {
        this.utils.adjustTextareaHeight(event.target as HTMLTextAreaElement);
      }, 0);
    }
  }

  disableKeyIndicatorWeight(selectedComponent: ComponentModel): boolean {
    return selectedComponent.type === ComponentType.TEXT
      || selectedComponent.type === ComponentType.BUTTON
      || selectedComponent.type === ComponentType.TITLE
      || selectedComponent.type === ComponentType.HTML
      || (selectedComponent?.roles?.some(x => x.name === RoleType.CUSTOMER && (x.accessibility.editable === false || x.accessibility.visible === false))
        && this.page.roles?.some(x => x.name === RoleType.CUSTOMER && !(x.accessibility.editable === false && x.accessibility.visible === false))
        && selectedComponent.keyIndicator!.weight == 0)
      || selectedComponent?.readOnly === true;
  }

  disableRegex(selectedComponent: ComponentModel): boolean {
    return selectedComponent?.roles?.some(x => x.name === RoleType.CUSTOMER && (x.accessibility.editable === false || x.accessibility.visible === false)) ||
      selectedComponent?.readOnly === true;
  }

  updateRoles(type: string, roleType: RoleType): void {
    const updateAccessibility = (items: { roles?: Role[] }[], role: Role | undefined) => {
      items.forEach(item => {
        const itemRole = item.roles!.find(role => role.name === roleType);
        if (itemRole) {
          itemRole.accessibility.editable = role?.accessibility.editable ?? false;
          itemRole.accessibility.visible = role?.accessibility.visible ?? false;
        }
      });
    };

    if (type === 'page') {
      const pageRole = this.page.roles!.find(role => role.name === roleType);
      const blocks = this.page.blocks!.filter(block =>
        block.roles.some(role => role.name === roleType && !role.isActive)
      );
      const components = blocks
        .flatMap(block => block.componentGroups.flatMap(group => group.components))
        .filter(component =>
          component.roles!.some(role => role.name === roleType && !role.isActive)
        );

      updateAccessibility(blocks, pageRole);
      updateAccessibility(components, pageRole);

    } else if (type === 'block' && this.selectedBlock) {
      const blockRole = this.selectedBlock.roles.find(role => role.name === roleType);
      const components = this.selectedBlock.componentGroups
        .flatMap(group => group.components)
        .filter(component =>
          component.roles?.some(role => role.name === roleType && !role.isActive)
        );

      updateAccessibility(components, blockRole);
    }

    this.isEdited = true;
  }


  resetKeyIndicatorWeight(type: string) {
    if (type === 'page') {
      //reset component weights, onde roles nao dependam da page
      var blocks: Block[] = this.page.blocks!.filter(block =>
        block.roles.some(role => role.name === RoleType.CUSTOMER && !role.isActive)
      );

      var components: ComponentModel[] = blocks
        .flatMap(block =>
          block.componentGroups.flatMap(group => group.components)
        )
        .filter(component =>
          component.keyIndicator!.weight !== undefined &&
          component.keyIndicator!.weight !== null &&
          component.keyIndicator!.weight > 0 &&
          component.roles!.some(role => role.name === RoleType.CUSTOMER && !role.isActive)
        );

      components.forEach(component => {
        component.keyIndicator!.weight = 0;
      });
    }
    else if (type === 'block' && this.selectedBlock) {
      //reset component weights, onde roles nao dependam do block
      var components: ComponentModel[] = this.selectedBlock.componentGroups
        .flatMap(group => group.components)
        .filter(component =>
          component.keyIndicator!.weight !== undefined &&
          component.keyIndicator!.weight !== null &&
          component.keyIndicator!.weight > 0 &&
          component.roles!.some(role => role.name === RoleType.CUSTOMER && !role.isActive)
        );
      components.forEach(component => {
        component.keyIndicator!.weight = 0;
      });
    }
    else if (type === 'component' && this.selectedComponent) {
      //reset component weight
      this.selectedComponent.keyIndicator!.weight = 0;
    }
    this.isEdited = true;
  }


  comparePages(page1: Page, page2: Page): boolean {
    return page1 && page2 ? page1.id === page2.id : page1 === page2;
  }

  customerCode: string = '00000006';
  soprodId: string = '';
  onOpenPreviewPageModal() {
    const dialogRef = this.dialog.open(PreviewChooseModalComponent, {
      width: '500px',
      data: {
        page: this.evaluatePage(structuredClone(this.page)),
        customerCode: this.customerCode,
        soprodId: this.soprodId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.customerCode = result.customerCode;
      this.soprodId = result.soprodId;
    });
  }

  dropBlock(event: CdkDragDrop<any[]>, list: Block[]): void {
    moveItemInArray(list, event.previousIndex, event.currentIndex);
    this.isEdited = true;
  }

  dropGroup(event: CdkDragDrop<any[]>, blockId: string, list: ComponentsGroup[]): void {
    moveItemInArray(list, event.previousIndex, event.currentIndex);
    const blockComponent = this.blockComponents.find(block => block.block.id === blockId);
    blockComponent?.updateComponentOrder();
    this.isEdited = true;
  }

  dropConnection(event: CdkDragDrop<any[]>): void {
    if (this.selectedComponent && this.selectedComponent.connections) {
      moveItemInArray(this.selectedComponent.connections, event.previousIndex, event.currentIndex);
      this.isEdited = true;
    }
  }

  dropOption(event: CdkDragDrop<any[]>): void {
    if (this.selectedComponent && this.selectedComponent.config && this.selectedComponent.config.options) {
      moveItemInArray(this.selectedComponent.config.options, event.previousIndex, event.currentIndex);
      this.isEdited = true;
    }
  }

  onReadOnlyUpdate(): void {
    if (this.selectedComponent?.readOnly) {
      this.dialogService.confirm(this.translationService.translate('Attention'), this.translationService.translate('Some fields of this component will be affected (key indicator and validator)'))
        .then((confirmed) => {
          if (confirmed) {
            this.selectedComponent!.isRequired = false;
            this.resetFieldsOnRolesChange('component');
          } else {
            this.selectedComponent!.readOnly = false;
          }
        });
    }
    this.isEdited = true;
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    if (this.isEdited || this.isVersionEdited) {
      $event.returnValue = 'You have unsaved changes! Do you really want to leave?';
    }
  }
  canDeactivate(): boolean {
    if (!this.isEdited && !this.isVersionEdited) {
      return true;
    }
    return window.confirm('You have unsaved changes! Do you really want to leave?');
  }

  maskSelected: string = "NONE";
  noneMask: ComponentMask = { type: 'NONE', mask: '', dropSpecialCharacters: false };

  getMasks(): void {
    this.generalParameterService.getGeneralParameters('MaskConfigs')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (param: GeneralParameter[] | GeneralParameter) => {
          this.maskConfigs = (param?.values?.length > 0) ? param.values as ComponentMask[] : [];
        },
        error: (error) => {
          this.maskConfigs = [];
        }
      });
  }
  onSelectMask(selectedType: string): void {
    if (!this.selectedComponent) return;
    this.isEdited = true;

    const config = this.maskConfigs.find(m => m.type === selectedType);
    if (config) {
      this.selectedComponent.config!.mask = { ...config };
    } else {
      this.selectedComponent.config!.mask = { ...this.noneMask };
    }
  }
  handleMaskInput(event: Event) {
    if (!this.selectedComponent) return;
    this.isEdited = true;

    const value = (event.target as HTMLInputElement).value;
    const isEmpty = !value || value.trim() === '';
    this.maskSelected = isEmpty ? 'NONE' : 'CUSTOM';

    this.selectedComponent.config!.mask = {
      type: this.maskSelected,
      mask: value,
      dropSpecialCharacters: false
    };

    this.adjustTextareaHeight(event);
  }

  regexSelected: string = "Empty";
  customRegex: boolean = false;

  getRegexes(): void {
    this.generalParameterService.getGeneralParameters('RegexTypes')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (param: GeneralParameter[] | GeneralParameter) => {
          if (param != null && param.values.length > 0) {
            this.regexTypes = (param.values) as RegexCategory[];
          }
        },
        error: (error) => {
          this.regexTypes = [];
        }
      });
  }

  onSelectRegex(regexSelected: string): void {
    if (this.selectedComponent) {
      var value = this.regexTypes.find(x => x.type === regexSelected)?.value;
      this.selectedComponent.regex = value;
      this.evaluateRegexType(this.selectedComponent.regex);
      this.isEdited = true;
    }
  }

  handleRegexInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;
    this.evaluateRegexType(currentValue);
    this.adjustTextareaHeight(event);
  }

  evaluateRegexType(currentValue?: string) {
    var findRegex = this.regexTypes.find(x => x.value === currentValue);

    if (findRegex) {
      this.regexSelected = findRegex.type;
      this.customRegex = false;
    }
    else if (currentValue === null || currentValue === undefined || currentValue === "") {
      this.regexSelected = "Empty";
      this.customRegex = false;
    }
    else {
      this.regexSelected = "Custom";
      this.customRegex = true;
    }
  }

  resetRegex() {
    if (this.selectedComponent) {
      this.selectedComponent.regex = "";
      this.evaluateRegexType(this.selectedComponent?.regex);
    }
  }

  resetFieldsOnRolesChange(type: string) {
    this.resetKeyIndicatorWeight(type);
    this.resetRegex();
  }

  componentSubcodeChanged() {
    if (this.selectedBlock) {
      setTimeout(() => {
        this.utils.updateTextProperty(this.selectedBlock, "subCode", /^[A-Z0-9_]+$/, /[^A-Z0-9_]/g);
        if (this.selectedBlock!.subCode == undefined || this.selectedBlock!.subCode == "") {
          this.selectedBlock!.isMultiple = false;
        }
      }, 0);
    }
  }

  componentTagChanged(event: Event, tagType: string) {
    this.adjustTextareaHeight(event);

    if (this.selectedComponent) {
      setTimeout(() => {
        this.utils.updateTextProperty(this.selectedComponent, tagType, /^[A-Z0-9_]+$/, /[^A-Z0-9_]/g);
      }, 0);
    }

    this.newUpdateListener();
  }

  verifyRegex(value: string): boolean {
    return /^[A-Z0-9_]+$/.test(value);
  }

  getConnectionsDefinitions() {
    this.connectionDefinitionService.getAllConnectionsDefinitions()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: ConnectionDefinition[]) => {
          this.connectionsDefinitions = data;
        },
        error: (error) => {
          this.snackBar.showError(this.translationService.translate('Error fetching connections definitions'));
        }
      });
  }

  onKeyIndicatorChange(value: string) {
    let newValue = parseInt(value, 10);

    if (isNaN(newValue) || newValue < 0) {
      newValue = 0;
    } else if (newValue > 100) {
      newValue = 100;
    }

    if (this.selectedComponent) {
      setTimeout(() => {
        this.selectedComponent!.keyIndicator!.weight = newValue;
      });
    }
    this.isEdited = true;
  }

  onColumnsChanged(value: string) {
    let newValue = parseInt(value, 10);

    if (isNaN(newValue) || newValue < 1) {
      newValue = 1;
    }

    if (this.selectedComponent) {
      setTimeout(() => {
        this.selectedComponent!.columns = newValue;
      });
    }

    this.isEdited = true;
  }

  onWidthChanged(value: string) {
    let newValue = parseInt(value, 10);

    if (isNaN(newValue) || newValue < 2) {
      newValue = 2;
    } else if (newValue > 12) {
      newValue = 12;
    }

    if (this.selectedComponent) {
      setTimeout(() => {
        this.selectedComponent!.size = newValue;
      });
    }

    this.isEdited = true;
  }

  copiedElements: ElementCopied[] = [];
  getCopiedElements() {
    var data = this.lStorage.getItemWithExpiry('copiedElements');
    if (data) {
      const parsedData = JSON.parse(data);
      this.copiedElements = parsedData;
    }
  }

  updateCopiedElements(copiedElements: ElementCopied[]) {
    this.copiedElements = copiedElements;
  }
  pasteAction(newComponentIds?: string[], newBlockId?: string, lastIndex?: number) {
    this.isEdited = true;

    if (newComponentIds) {
      newComponentIds.forEach(newCompId => {
        this.newComponentsIds.push(newCompId);
      });
    }
    if (newBlockId) {
      this.newBlocksIds.push(newBlockId);
    }

    if (lastIndex) {
      this.goToStep(lastIndex);
    }
  }

  tags: Tag[] = [];
  pageHistories: Page[] = [];
  onOpenTagsModal() {
    if (this.tags.length == 0) {
      this.generalParameterService.getGeneralParameters('Tags')
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (param: GeneralParameter[] | GeneralParameter) => {
            if (param != null && param.values.length > 0) {
              this.tags = (param.values) as Tag[];
            }
          },
          error: (error) => {
            this.tags = [];
          }
        });
    }

    this.dialog.open(TagsModalComponent, {
      width: '1000px',
      data: {
        tags: this.tags,
      }
    });
  }

  onOpenPageHistoryModal() {
    this.pageService.getPageHistory(this.pageId!)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (param: Page[]) => {
          if (param != null) {
            this.pageHistories = param as Page[];
            const dialogRef = this.dialog.open(PageHistoryModalComponent, {
              width: '1000px',
              data: {
                pageHistories: this.pageHistories,
                isEdited: this.isEdited
              }
            });

            dialogRef.afterClosed().subscribe((selectedPage: Page) => {
              if (selectedPage) {
                this.isEdited = false;
                this.isVersionEdited = true;
                this.isImported = false;
                this.page = selectedPage;
              }
            });
          }
        },
        error: (error) => {
          this.pageHistories = [];
        }
      });


  }

  newUpdateListener() {
    this.isEdited = true;
  }

  shouldDisplayComponent(component: ComponentModel): boolean {
    const matchesText = !this.searchComponentsFilters.text || (
      (component.title || component.config?.placeholder || component.config?.text || '')
        .toLowerCase()
        .includes(this.searchComponentsFilters.text.toLowerCase())
    );

    const matchesOnlyNew = !this.searchComponentsFilters.onlyNew || this.newComponentsIds.includes(component.id);
    const matchesConditions = !this.searchComponentsFilters.onlyConditions || (component.conditions != undefined && component.conditions?.length > 0);
    const matchesConnections = !this.searchComponentsFilters.onlyConnections || (component.connections != undefined && component.connections?.length > 0);
    const matchesMultiple = !this.searchComponentsFilters.onlyMultiple || (component.config?.multipleAnswers === true && (component.multipleConfig?.maxQuantity == undefined || component.multipleConfig?.maxQuantity > 1));
    const matchesKeyIndicatorWeight =
      (!this.searchComponentsFilters.withKeyIndicatorWeight || (component.keyIndicator?.weight != undefined && component.keyIndicator.weight > 0)) &&
      (!this.searchComponentsFilters.withoutKeyIndicatorWeight || component.keyIndicator?.weight == undefined || component.keyIndicator.weight === 0);

    const matchesType = this.searchComponentsFilters.types.some(type => {
      switch (type) {
        case 'INPUT_TEXT':
          return component.type === ComponentType.INPUT && component.config?.inputType === InputType.TEXT;
        case 'TEXT_AREA':
          return component.type === ComponentType.INPUT && component.config?.inputType === InputType.TEXT_AREA;
        case 'NUMBER':
          return component.type === ComponentType.INPUT && component.config?.inputType === InputType.NUMBER;
        case 'DATE':
          return component.type === ComponentType.INPUT && component.config?.inputType === InputType.DATE;
        case 'COLOR':
          return component.type === ComponentType.INPUT && component.config?.inputType === InputType.COLOR_PICKER;
        case 'FILE':
          return component.type === ComponentType.INPUT && component.config?.inputType === InputType.FILE;

        case 'LIST_DROP':
          return component.type === ComponentType.SELECT && component.config?.selectType === SelectType.LIST_DROP;
        case 'LIST_NO_DROP':
          return component.type === ComponentType.SELECT && component.config?.selectType === SelectType.LIST_NO_DROP;
        case 'LIST_CARD':
          return component.type === ComponentType.SELECT && component.config?.selectType === SelectType.LIST_CARD;

        case 'CHOICE_BUTTON':
          return component.type === ComponentType.CHECKBOX;
        case 'SCHEDULE':
          return component.type === ComponentType.SCHEDULE;
        case 'BUTTON':
          return component.type === ComponentType.BUTTON;
        case 'TEXT':
          return component.type === ComponentType.TEXT;
        case 'TITLE':
          return component.type === ComponentType.TITLE;
        case 'HTML':
          return component.type === ComponentType.HTML;
        case 'ADDRESS':
          return component.type === ComponentType.ADDRESS;
        case 'INTITULE':
          return component.type === ComponentType.INTITULE;
        case 'URL':
          return component.type === ComponentType.URL;
        case 'VISUAL_PUBLICATION':
          return component.type === ComponentType.VISUAL_PUBLICATION;
        case 'ACTIVITY_PRESTATIONS':
          return component.type === ComponentType.ACTIVITY_PRESTATIONS;
        default:
          return false;
      }
    });

    const matchesRoles = this.matchesRolesFilter(component);

    return (
      matchesText &&
      matchesType &&
      matchesOnlyNew &&
      matchesConditions &&
      matchesConnections &&
      matchesMultiple &&
      matchesKeyIndicatorWeight &&
      matchesRoles
    );
  }

  shouldDisplayBlock(block: Block): boolean {
    if (!this.searchComponentsFilters.text) return true;

    const blockMatches = block.title?.toLowerCase().includes(this.searchComponentsFilters.text.toLowerCase()) && this.matchesRolesFilter(block);

    const componentMatches = block.componentGroups?.some(group =>
      group.components?.some(c => this.shouldDisplayComponent(c))
    );
    return blockMatches || componentMatches;
  }

  matchesRolesFilter(item: Block | ComponentModel) {
    const accessibility = this.searchComponentsFilters.accessibility;
    const includedRole = this.searchComponentsFilters.includedRole;
    const excludedRole = this.searchComponentsFilters.excludedRole;

    if (!accessibility) return true;

    type AccessibilityKey = keyof Accessibility; // 'visible' | 'editable'
    const permissionKey = accessibility.toLowerCase() as AccessibilityKey;

    if (includedRole && includedRole != RoleType.ADMIN.toString()) {
      const role = item.roles?.find(x => x.name.toString() === includedRole);
      if (!role?.accessibility?.[permissionKey]) {
        return false;
      }
    }

    if (excludedRole && excludedRole != RoleType.ADMIN.toString()) {
      const role = item.roles?.find(x => x.name.toString() === excludedRole);
      if (role?.accessibility?.[permissionKey] === true) {
        return false;
      }
    }

    return true;
  }

  resetDisplayFilter() {
    this.searchComponentsFilters = {
      text: '',
      types: this.componentDisplayTypes.map(option => option.value),
      onlyNew: false,
      onlyMultiple: false,
      onlyConditions: false,
      onlyConnections: false,
      withKeyIndicatorWeight: false,
      withoutKeyIndicatorWeight: false,
      includedRole: '',
      excludedRole: '',
      accessibility: ''
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent) {
    this.isMobile = window.innerWidth <= 1023;
  }

  onVisualPublicationTypeChange() {
    if (this.selectedComponent) {
      if (this.selectedComponent.config?.contentAPISubType == "LOGO") {
        this.selectedComponent.config.multipleAnswers = false;
        this.resetMultipleConfig();
      }
      else {
        this.selectedComponent.config!.multipleAnswers = true;
        this.selectedComponent.multipleConfig!.maxQuantity = undefined;
      }
    }

    this.newUpdateListener();
  }

  canChangeMultipleCheckbox(): boolean {
    var hasConnectionWithHandle = this.selectedComponent?.connections?.some(x => x.connectionDefinition?.values?.some(y => y.handle));
    return !hasConnectionWithHandle;
  }

  onConnectionBuilded(handle: string | undefined) {
    if (handle && this.selectedComponent) {
      if (handle == "SINGLE") {
        this.selectedComponent.config!.multipleAnswers = false;
        this.resetMultipleConfig();
      }
      else if (handle == "MULTIPLE") {
        this.selectedComponent.config!.multipleAnswers = true;
        this.selectedComponent.multipleConfig!.maxQuantity = undefined;
      }
    }
    this.newUpdateListener();
  }

  VersionBoldIndex(text: string | undefined): string {
    return this.utils.VersionBoldIndex(text);
  }

  onRestorePage() {
    if (this.isEdited) {
      this.dialogService.confirm(
        this.translationService.translate('Restore'),
        this.translationService.translate('Are you sure you want to revert to the latest version?') + ' ' + this.translationService.translate('Any unsaved changes will be lost.')
      )
        .then((confirmed) => {
          if (confirmed) {
            this.onRestorePageAction();
          }
        });
    } else {
      this.onRestorePageAction();
    }

  }

  onRestorePageAction() {
    this.pageService.getPageDetails(this.pageId!)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (param: Page) => {
          if (param != null) {
            this.isEdited = false;
            this.isVersionEdited = true;
            this.isImported = false;
            this.page = param;
          }
        }
      });
  }

  onImportExternalPage() {
    this.dialogService.confirm(
      this.translationService.translate('Import'),
      this.translationService.translate('Are you sure you want to replace the current page with an imported?') + ' ' + this.translationService.translate('Any unsaved changes will be lost.')
    )
      .then((confirmed) => {
        if (confirmed) {
          this.loadingService.show();
          this.pageService.getExternalPage(this.pageId!)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (page: Page | null) => {
                if (page != null) {
                  this.isEdited = true;
                  this.isVersionEdited = false;
                  this.isImported = true;
                  this.page = {
                    ...page,
                    offers: this.page.offers,
                    parentPage: this.page.parentPage
                  };
                }
                else {
                  this.snackBar.showError(this.translationService.translate('Page Not Found'));
                }
                this.loadingService.hide();
              },
              error: (error) => {
                if (error.status == 404) {
                  this.snackBar.showError(this.translationService.translate('Page Not Found'));
                }
                else {
                  this.snackBar.showError(this.translationService.translate('Error fetching page'));
                }
                this.loadingService.hide();
              }
            });
        }
      });
  }

  InitEditor(text: string | undefined): string {
    if (text && text.trim().length > 0) {
      return text + '';
    } else {
      return '<span style="font-size: small;"></span>';

    }
  }

  private isCleaning = false;
  onEditorChange(html: string): void {
    if (this.isCleaning) return;

    setTimeout(() => {
      const root = this.editorEl?.nativeElement;
      if (!root) return;

      const toggleBtn = root.querySelector('#toggleEditorMode-');
      if (toggleBtn?.classList.contains('active')) return;

      const editable = root.querySelector('.angular-editor-textarea') as HTMLElement;
      if (!editable) return;

      editable.querySelectorAll<HTMLElement>('h1,h2,h3,h4,h5,h6')
        .forEach(h => {
          h.style.removeProperty('font-size');
          h.querySelectorAll<HTMLElement>('*')
            .forEach(child => child.style.removeProperty('font-size'));
        });

      this.isCleaning = true;
      this._editorText = editable.innerHTML;
      this.selectedComponent!.config!.text = editable.innerHTML;
      this.isCleaning = false;
    });
  }

  private isCleaningBlockDone = false;
  onEditorBlockDoneChange(html: string): void {
    if (this.isCleaningBlockDone) return;

    setTimeout(() => {
      const root = this.editorBlockDoneEl?.nativeElement;
      if (!root) return;

      const editable = root.querySelector('.angular-editor-textarea') as HTMLElement;
      if (!editable) return;

      editable.querySelectorAll<HTMLElement>('h1,h2,h3,h4,h5,h6')
        .forEach(h => {
          h.style.removeProperty('font-size');
          h.querySelectorAll<HTMLElement>('*')
            .forEach(child => child.style.removeProperty('font-size'));
        });

      this.isCleaningBlockDone = true;
      this._editorBlockDoneText = editable.innerHTML;
      this.page.blockDone!.title = editable.innerHTML;
      this.isCleaningBlockDone = false;
    });
  }

  stripHtml(html: string){
    return this.utils.stripHtml(html);
  }

  isJson(value: string){
    return this.utils.isValidJson(value);
  }

  isHtml(value: string){
    return this.utils.containsHtml(value);
  }

  beautifyJSON(value: string) {
    return this.utils.beautifyJSON(value) ?? value;
  }
}
